import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { registerLocale } from '@abp/ng.core/locale';
import { ConfirmationService, ThemeSharedModule } from '@abp/ng.theme.shared';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiInterceptor, CoreModule } from '@abp/ng.core';
import { environment } from 'src/environments/environment';
import { NgbModule, NgbRatingConfig } from '@ng-bootstrap/ng-bootstrap';
import { InlineSVGModule } from 'ng-inline-svg';
// import { CRUDTableModule } from 'src/app/_metronic/shared/crud-table';
import { qComponentsModule } from '../core/qcomponents/qcomponents.module';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { LayoutUtilsService } from 'src/app/core/layout-utils.service';
import { NavigationService } from '../core/qservices/navigation.service';

import { GridsterModule } from 'angular-gridster2';

import { PerfectScrollbarModule, PerfectScrollbarConfigInterface, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    wheelPropagation: true
};


import { NgxSliderModule } from '@angular-slider/ngx-slider';

import { FlexLayoutModule } from '@angular/flex-layout';


import { WebshopRoutingModule } from './webshop-routing.module';

import { ArtikelGruppeListComponent } from './artikelgruppen/artikel-gruppe-list/artikel-gruppe-list.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { WebshopViewComponent } from './webshops/webshop-view/webshop-view.component';
import { TopSection1Component } from './webshops/topsections/top-section1/top-section1.component';
import { MenuSection1Component } from './webshops/menusections/menu-section1/menu-section1.component';
import { InfoSection1Component } from './webshops/infosections/info-section1/info-section1.component';
import { MainSection1Component } from './webshops/mainsections/main-section1/main-section1.component';
import { BottomSection1Component } from './webshops/bottomsections/bottom-section1/bottom-section1.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { Login1Component } from './webshops/logins/login1/login1.component';
import { MatInputModule } from '@angular/material/input';
import { MatBadgeModule } from '@angular/material/badge';
import { TopLevelNav1Component } from './webshops/nav/navs/top-level-nav1/top-level-nav1.component';
import { NavBox1Component } from './webshops/nav/navboxes/nav-box1/nav-box1.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { FilterContainer1Component } from './webshops/filter/filtercontainers/filter-container1/filter-container1.component';
import { FilterBox1Component } from './webshops/filter/filterboxes/filter-box1/filter-box1.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NavService } from './webshops/nav/shared/nav.service';
import { FilterContainerCategory1Component } from './webshops/filter/filtercontainers/filter-container-category1/filter-container-category1.component';
import { FilterBoxCategory1Component } from './webshops/filter/filterboxes/filter-box-category1/filter-box-category1.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import {CarouselModule} from 'primeng/carousel';
import { MatCardModule } from '@angular/material/card';
import { CardModule } from 'primeng/card';
import { ArtikelList1Component } from './artikels/artikel-list1/artikel-list1.component';
import { ArtikelListWidget1Component } from './artikels/artikel-list-widget1/artikel-list-widget1.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ArtikelQuickView1Component } from './artikels/artikel-quick-view1/artikel-quick-view1.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { WarenkorbListComponent } from './webshops/warenkorbs/warenkorb-list/warenkorb-list.component';
import { WarenkorbEditComponent } from './webshops/warenkorbs/warenkorb-edit/warenkorb-edit.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ArtikelbildThumbs1Component } from './artikels/artikelbild-thumbs1/artikelbild-thumbs1.component';
import { ArtikeldokumenteListComponent } from './artikels/artikeldokumente/artikeldokumente-list/artikeldokumente-list.component';
import { ArtikelzubehoerComponent } from './artikels/artikelzubehoer/artikelzubehoer.component';
import { KurseComponent } from './artikels/kurse/kurse.component';
import { AdvertiseComponent } from './webshops/advertise/advertise.component';
import { FilterChipsComponent } from './webshops/filter/filter-chips/filter-chips.component';
import { MatChipsModule } from '@angular/material/chips';
import { AktionsArtikelComponent } from './artikels/aktions-artikel/aktions-artikel.component';
import { WebshopHomeComponent } from './webshops/webshophome/webshophome.component';
import { CheckoutComponent_new } from './webshops/checkout_new/checkout_new.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioModule } from '@angular/material/radio';
import { WebshopAccountComponent } from './webshops/account/account.component';

@NgModule({
    declarations: [
        ArtikelGruppeListComponent,
        WebshopViewComponent,
        TopSection1Component,
        MenuSection1Component,
        InfoSection1Component,
        MainSection1Component,
        BottomSection1Component,
        Login1Component,
        TopLevelNav1Component,
        NavBox1Component,
        FilterContainer1Component,
        FilterBox1Component,
        FilterContainerCategory1Component,
        FilterBoxCategory1Component,
        ArtikelList1Component,
        ArtikelListWidget1Component,
        ArtikelQuickView1Component,
        WarenkorbListComponent,
        WarenkorbEditComponent,
        ArtikelbildThumbs1Component,
        ArtikeldokumenteListComponent,
        AdvertiseComponent,
        ArtikelzubehoerComponent,
        KurseComponent,
        FilterChipsComponent,
        AktionsArtikelComponent,
        WebshopHomeComponent,
        WebshopAccountComponent,
        CheckoutComponent_new

    ],
    imports: [
        CommonModule,
        RouterModule,
        WebshopRoutingModule,
        ScrollingModule,
        CoreModule.forRoot({
            environment,
            registerLocaleFn: registerLocale()
        }),
        ThemeSharedModule.forRoot(),
        HttpClientModule,

        DragDropModule,
        PerfectScrollbarModule,
        NgxSliderModule,

        FlexLayoutModule,


        // CRUDTableModule,
        qComponentsModule,
        InlineSVGModule,
        NgbModule,

        // Material Design
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatMenuModule,
        MatDialogModule,
        MatExpansionModule,
        MatListModule,
        MatSidenavModule,
        MatBadgeModule,
        MatToolbarModule,
        MatCardModule,
        MatPaginatorModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        MatChipsModule,
        MatStepperModule,
        MatRadioModule,
        // PrimeNG
        CarouselModule,
        CardModule,
        GridsterModule,
        
    ],
    providers: [
        NgbRatingConfig,
        {
            provide: MAT_DATE_LOCALE, useValue: 'de-DE'
        },
            ApiInterceptor,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true
        },
            {
                provide: MAT_DIALOG_DEFAULT_OPTIONS,
                useValue: {
                hasBackdrop: true,
                panelClass: 'mat-dialog-override',
                // panelClass: 'kt-mat-dialog-container__wrapper',
                height: 'auto',
                width: '700px'
            }
        },
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
        },

        // {
        //	    provide: OWL_DATE_TIME_LOCALE, useValue: 'de'
        // },
    
        {provide:MatDialogRef , useValue:{} },

        { provide: MAT_DIALOG_DATA, useValue: {} },
    
        // COMMON - Services
        LayoutUtilsService,
        
        DialogService,
        MessageService,
        ConfirmationService,
    
        NavigationService,
        NavService,
    ],
    entryComponents: [
    ],
})
export class WebshopModule { }
